if (!window.xmV3GatewayController) {
  const controller = new AbortController();
  let sceneObserver;
  window.xmV3GatewayController = controller;

  document.addEventListener('keydown', (event) => {
    const openGateway = document.querySelector('.xm-v3-gateway details[open]');
    if (event.key === 'Tab' && openGateway) {
      const focusable = [...openGateway.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => {
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
        });
      if (focusable.length) {
        const active = document.activeElement;
        const currentIndex = focusable.indexOf(active);
        const nextIndex = event.shiftKey
          ? (currentIndex <= 0 ? focusable.length - 1 : currentIndex - 1)
          : (currentIndex < 0 || currentIndex === focusable.length - 1 ? 0 : currentIndex + 1);
        event.preventDefault();
        focusable[nextIndex].focus();
      }
      return;
    }

    if (event.key === 'Escape' && openGateway) {
      event.preventDefault();
      const trigger = openGateway.querySelector('.xm-v3-gateway__trigger');
      const drawer = openGateway.closest('header-drawer');
      if (typeof drawer?.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(event, trigger);
      } else {
        openGateway.open = false;
        trigger?.focus();
      }
      document.body.classList.remove('overflow-hidden');
      return;
    }

    const trigger = event.target.closest('.xm-v3-gateway__trigger');
    if (!trigger || ![' ', 'Spacebar'].includes(event.key)) return;

    event.preventDefault();
    trigger.click();
  }, { signal: controller.signal });

  document.addEventListener('click', (event) => {
    const activation = event.target.closest('[data-xm-gateway-open]');
    if (!activation) return;

    const gateway = document.querySelector('.xm-v3-gateway details');
    const trigger = gateway?.querySelector('summary');
    if (!gateway || !trigger) return;

    gateway.open = true;
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => {
      const current = gateway.querySelector('.xm-v2-nav__link[aria-current="page"]');
      (current || gateway.querySelector('.xm-v2-nav__link') || trigger).focus();
    });
  }, { signal: controller.signal });

  document.querySelectorAll('.xm-v3-gateway details').forEach((gateway) => {
    const trigger = gateway.querySelector('.xm-v3-gateway__trigger');
    gateway.addEventListener('toggle', () => {
      trigger?.setAttribute('aria-expanded', gateway.open ? 'true' : 'false');
      document.body.classList.toggle('overflow-hidden', gateway.open);
    }, { signal: controller.signal });
  });

  const contactForm = document.querySelector('#XMV3ContactForm');
  if (contactForm) {
    const parameters = new URLSearchParams(window.location.search);
    const intent = parameters.get('intent');
    const service = parameters.get('service');
    const approvedIntents = new Set(['general', 'service', 'consultation']);
    const approvedServices = { tech: 'XM Tech', studio: 'XM Studio', growth: 'Growth & Marketing', 'business-systems': 'Business Systems', 'case-intelligence': 'XM Case Intelligence' };

    if (approvedIntents.has(intent)) {
      const intentOption = contactForm.querySelector(`[data-xm-contact-intent="${intent}"]`);
      if (intentOption) intentOption.selected = true;
    }
    if (approvedServices[service]) {
      const serviceField = contactForm.querySelector('[data-xm-contact-service]');
      if (serviceField) serviceField.value = approvedServices[service];
      else {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[service]';
        hidden.value = approvedServices[service];
        contactForm.append(hidden);
      }
      const scope = document.createElement('p');
      scope.className = 'xm-v3-contact__scope';
      scope.textContent = `${document.documentElement.lang.toLowerCase().startsWith('lt') ? 'Užklausa dėl' : 'Enquiry about'} ${approvedServices[service]}`;
      contactForm.prepend(scope);
    }
  }

  const sceneTargets = document.querySelectorAll([
    '.xm-v3-public-portals',
    '.xm-v3-home-chapter',
    '.xm-v3-home-scene',
    '.xm-v3-route-scene',
    '.xm-v3-founder-signal',
    '.xm-v3-service-path',
    '.xm-services-commercial__hero',
    '.xm-services-commercial__detail',
    '.xm-v3-contact',
    '.xm-v3-return',
  ].join(','));

  if ('IntersectionObserver' in window && sceneTargets.length) {
    document.documentElement.dataset.xmSceneObserver = 'ready';
    sceneObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.toggleAttribute('data-xm-scene-active', entry.isIntersecting);
      });
    }, { rootMargin: '12% 0px -12%', threshold: 0.08 });
    sceneTargets.forEach((scene) => sceneObserver.observe(scene));
  }

  const orbit = document.querySelector('.xm-v3-home-orbit__visual');
  let orbitAfterimage;

  const acquireOrbit = (link) => {
    if (!orbit || !link?.closest('.xm-v3-home-orbit__nav')) return;
    const item = link.closest('.xm-v2-nav__item');
    const nodes = [...orbit.querySelectorAll('.xm-v2-nav__item')];
    const index = nodes.indexOf(item);
    if (index < 0) return;
    window.clearTimeout(orbitAfterimage);
    nodes.forEach((node) => node.removeAttribute('data-xm-orbit-acquired'));
    item.setAttribute('data-xm-orbit-acquired', '');
    const point = item.getBoundingClientRect();
    const frame = orbit.getBoundingClientRect();
    orbit.style.setProperty('--xm-orbit-x', `${((point.left + frame.width * 0.24 - frame.left) / (frame.width * 1.48)) * 100}%`);
    orbit.style.setProperty('--xm-orbit-y', `${((point.top + frame.height * 0.24 - frame.top) / (frame.height * 1.48)) * 100}%`);
    orbit.querySelector('.xm-v2-nav')?.style.setProperty('--xm-orbit-angle', `${index * 45}deg`);
    orbit.dataset.xmOrbitState = 'acquire';
  };

  const releaseOrbit = () => {
    if (!orbit) return;
    window.clearTimeout(orbitAfterimage);
    orbit.dataset.xmOrbitState = 'afterimage';
    orbitAfterimage = window.setTimeout(() => {
      orbit.removeAttribute('data-xm-orbit-state');
      orbit.querySelectorAll('[data-xm-orbit-acquired]').forEach((item) => item.removeAttribute('data-xm-orbit-acquired'));
      orbit.querySelector('.xm-v2-nav')?.style.setProperty('--xm-orbit-angle', '0deg');
    }, 620);
  };

  document.addEventListener('pointerover', (event) => {
    const link = event.target.closest('.xm-v3-home-orbit__nav .xm-v2-nav__link');
    if (link && !link.contains(event.relatedTarget)) acquireOrbit(link);
  }, { signal: controller.signal });
  document.addEventListener('focusin', (event) => {
    acquireOrbit(event.target.closest('.xm-v3-home-orbit__nav .xm-v2-nav__link'));
  }, { signal: controller.signal });
  document.addEventListener('pointerout', (event) => {
    const link = event.target.closest('.xm-v3-home-orbit__nav .xm-v2-nav__link');
    if (link && !link.contains(event.relatedTarget)) releaseOrbit();
  }, { signal: controller.signal });
  document.addEventListener('focusout', (event) => {
    if (event.target.closest('.xm-v3-home-orbit__nav .xm-v2-nav__link')) releaseOrbit();
  }, { signal: controller.signal });
  document.addEventListener('click', (event) => {
    const route = event.target.closest('.xm-v3-home-orbit__nav .xm-v2-nav__link');
    if (route) acquireOrbit(route);
  }, { signal: controller.signal });

  const menuField = document.querySelector('.xm-v3-home-menu .xm-v3-gateway__field');
  const menuCore = menuField?.querySelector('.xm-v3-gateway__energy');
  let menuTimers = [];
  let menuSelection;

  const clearMenuTimers = () => {
    menuTimers.forEach((timer) => window.clearTimeout(timer));
    menuTimers = [];
  };

  const acquireMenu = (link, deliberate = false) => {
    if (!matchMedia('(max-width: 749px)').matches || !menuField || !menuCore || !link || !link.closest('.xm-v3-gateway details[open]')) return;
    const item = link.closest('.xm-v2-nav__item');
    if (!item || menuSelection === item && menuField.dataset.xmMenuState !== 'idle' && !deliberate) return;
    clearMenuTimers();
    menuSelection = item;
    menuField.querySelectorAll('[data-xm-menu-acquired]').forEach((node) => node.removeAttribute('data-xm-menu-acquired'));
    item.setAttribute('data-xm-menu-acquired', '');
    const field = menuField.getBoundingClientRect();
    const node = item.getBoundingClientRect();
    const center = menuCore.getBoundingClientRect();
    const x = node.left + (item.matches(':nth-child(n+2):nth-child(-n+5)') ? 0 : node.width) - field.left;
    const y = node.top + node.height / 2 - field.top;
    const coreX = center.left + center.width / 2 - field.left;
    const coreY = center.top + center.height / 2 - field.top;
    const angle = Math.atan2(y - coreY, x - coreX) * 180 / Math.PI;
    menuField.style.setProperty('--xm-menu-x', `${x}px`);
    menuField.style.setProperty('--xm-menu-y', `${y}px`);
    menuField.style.setProperty('--xm-menu-angle', `${angle}deg`);
    menuField.style.setProperty('--xm-menu-distance', `${Math.max(0, Math.hypot(x - coreX, y - coreY) - 7)}px`);
    menuField.style.setProperty('--xm-menu-segment-angle', `${angle + 90}deg`);
    menuField.dataset.xmMenuState = 'acquire';
    menuTimers.push(window.setTimeout(() => {
      menuField.dataset.xmMenuState = 'reaction';
    }, 190));
    menuTimers.push(window.setTimeout(() => { menuField.dataset.xmMenuState = 'afterimage'; }, 580));
    menuTimers.push(window.setTimeout(() => { menuField.dataset.xmMenuState = 'settled'; }, 1220));
  };

  document.addEventListener('pointerover', (event) => {
    const link = event.target.closest('.xm-v3-home-menu .xm-v3-gateway__paths .xm-v2-nav__link');
    if (link && event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches && !link.contains(event.relatedTarget)) acquireMenu(link);
  }, { signal: controller.signal });
  document.addEventListener('focusin', (event) => {
    acquireMenu(event.target.closest('.xm-v3-home-menu .xm-v3-gateway__paths .xm-v2-nav__link'));
  }, { signal: controller.signal });
  document.addEventListener('pointerdown', (event) => {
    acquireMenu(event.target.closest('.xm-v3-home-menu .xm-v3-gateway__paths .xm-v2-nav__link'), true);
  }, { signal: controller.signal });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.xm-v3-home-menu .xm-v3-gateway__paths .xm-v2-nav__link');
    if (!link) return;
    try { sessionStorage.setItem('xmV3OrbitArrival', String(Date.now())); } catch {}
    if (!matchMedia('(max-width: 749px)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const target = link.href;
    if (!target) return;
    event.preventDefault();
    acquireMenu(link, event.detail === 0);
    menuTimers.push(window.setTimeout(() => window.location.assign(target), 790));
  }, { signal: controller.signal });
  menuField?.closest('details')?.addEventListener('toggle', (event) => {
    if (event.target.open) {
      menuField.dataset.xmMenuState = 'idle';
      return;
    }
    clearMenuTimers();
    menuField.removeAttribute('data-xm-menu-state');
    menuField.querySelectorAll('[data-xm-menu-acquired]').forEach((node) => node.removeAttribute('data-xm-menu-acquired'));
    menuSelection = null;
  }, { signal: controller.signal });

  // Reactions belong to the action that caused them. Energy appears before the brief human signal.
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let lastVibeReaction = 0;
  const sourceReactionTimes = new WeakMap();
  const emitVibeReaction = (source, palette, count = 8) => {
    if (!source || navigator.connection?.saveData || Date.now() - lastVibeReaction < 1700 || Date.now() - (sourceReactionTimes.get(source) || 0) < 6000) return;
    const rect = source.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > innerHeight || rect.right < 0 || rect.left > innerWidth) return;
    lastVibeReaction = Date.now();
    sourceReactionTimes.set(source, lastVibeReaction);
    source.setAttribute('data-xm-vibe-activated', '');
    window.setTimeout(() => source.removeAttribute('data-xm-vibe-activated'), 1100);
    if (reducedMotion.matches) return;
    const burst = document.createElement('span');
    burst.className = 'xm-vibe-reaction';
    burst.setAttribute('aria-hidden', 'true');
    burst.style.left = `${Math.max(28, Math.min(innerWidth - 28, rect.left + rect.width / 2))}px`;
    burst.style.top = `${Math.max(36, Math.min(innerHeight - 36, rect.top + rect.height / 2))}px`;
    for (let index = 0; index < count; index += 1) {
      const item = document.createElement('span');
      const angle = (Math.PI * 2 * index) / count - Math.PI / 2;
      const radius = index < 3 ? 70 + index * 13 : 45 + (index % 4) * 16;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius - 12;
      item.textContent = palette[index % palette.length];
      item.style.setProperty('--xm-vibe-x', `${x.toFixed(1)}px`);
      item.style.setProperty('--xm-vibe-y', `${y.toFixed(1)}px`);
      item.style.setProperty('--xm-vibe-turn', `${(index % 2 ? 1 : -1) * (12 + index * 3)}deg`);
      item.style.setProperty('--xm-vibe-size', index < 3 ? `${1.7 + index * 0.2}rem` : `${0.88 + (index % 3) * 0.18}rem`);
      item.style.setProperty('--xm-vibe-blur', index > 5 ? '0.8px' : '0px');
      item.style.setProperty('--xm-vibe-delay', `${155 + (index % 4) * 32}ms`);
      item.style.setProperty('--xm-vibe-opacity', index < 3 ? '0.96' : `${0.45 + (index % 3) * 0.12}`);
      burst.append(item);
    }
    document.documentElement.append(burst);
    window.setTimeout(() => burst.remove(), 1450);
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0 || event.target.closest('.xm-v3-gateway__paths')) return;
    const gateway = event.target.closest('[data-xm-gateway-open]');
    if (gateway) return;
    const founder = event.target.closest('.xm-v3-founder-signal__post a');
    if (founder) return emitVibeReaction(founder, founder.closest('.xm-v3-founder-signal__post--beauty') ? ['🤩', '💜', '🔥'] : ['🔥', '😈', '⚡'], 9);
    const beauty = event.target.closest('.xm-v3-shop-door--beauty');
    if (beauty) return emitVibeReaction(beauty, ['🤩', '💜', '👀'], 9);
    const xmtee = event.target.closest('.xm-v3-shop-door--xmtee');
    if (xmtee) return emitVibeReaction(xmtee, ['🔥', '😈', '⚡'], 9);
    const assistant = event.target.closest('[data-xm-intelligence-entry]');
    if (assistant && !document.querySelector('[data-xm-destination="case-intelligence"]')) return emitVibeReaction(assistant, ['👀', '⚡', '💜'], 8);
    const serviceAction = event.target.closest('.xm-v3-service-family .xm-v3-signal-action');
    if (serviceAction) emitVibeReaction(serviceAction, ['⚡', '💜'], 8);
  }, { signal: controller.signal });

  document.addEventListener('click', (event) => {
    if (event.detail !== 0) return;
    const action = event.target.closest('.xm-v3-founder-signal__post a, .xm-v3-shop-door, [data-xm-intelligence-entry], .xm-v3-service-family .xm-v3-signal-action');
    if (action && !action.closest('.xm-v3-gateway__paths')) emitVibeReaction(action, ['⚡', '💜', '👀'], 8);
  }, { signal: controller.signal });

  try {
    const arrival = Number(sessionStorage.getItem('xmV3OrbitArrival'));
    sessionStorage.removeItem('xmV3OrbitArrival');
    if (arrival && Date.now() - arrival < 5000) {
      document.documentElement.classList.add('xm-v3-route-arrived');
      window.setTimeout(() => document.documentElement.classList.remove('xm-v3-route-arrived'), 1050);
    }
  } catch {}

  const subscribeSuccess = document.querySelector('.xm-v3-home-subscribe__notice[role="status"]');
  if (subscribeSuccess) requestAnimationFrame(() => emitVibeReaction(subscribeSuccess, ['🔥', '💜', '⚡', '🫡'], 10));

  const liveForms = document.querySelectorAll('#XMHomeSubscribe, #XMV3ContactForm');
  liveForms.forEach((form) => form.addEventListener('submit', () => {
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    form.setAttribute('aria-busy', 'true');
    window.setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      form.removeAttribute('aria-busy');
    }, 12000);
  }, { signal: controller.signal }));
  window.addEventListener('pageshow', () => liveForms.forEach((form) => {
    form.removeAttribute('aria-busy');
    const button = form.querySelector('button[type="submit"]');
    button?.removeAttribute('aria-busy');
    if (button) button.disabled = false;
  }), { signal: controller.signal });

  window.addEventListener('pagehide', () => {
    sceneObserver?.disconnect();
    window.clearTimeout(orbitAfterimage);
    clearMenuTimers();
    document.querySelectorAll('.xm-v3-gateway details[open]').forEach((gateway) => {
      gateway.open = false;
    });
    document.body.classList.remove('overflow-hidden');
  }, { signal: controller.signal });
}
